/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import dynamic from 'next/dynamic';
import {GenericObject} from '@ion/core/src/types/entities';
import {Timeline} from '../tools/TimeSliderTool';
import {MapToolPositions} from '../types/types';
import {addComponent, removeComponent} from './simpleMapUtils';

type TimeSliderRef = {
  destroy: (map: __esri.Map, view: __esri.MapView) => Promise<void>;
};

type TimeSliderTriggerProps = {
  map: __esri.Map;
  view: __esri.MapView;
  timeline: Timeline;
  timeSliderDisabled: boolean;
  assetsHistory: any[];
  featureFilter: GenericObject;
};

let timeSliderMethodsRef: TimeSliderRef | null = null;

const DynamicAssetHistoryMap = dynamic(() => import('@ion/dls/src/maps/components/TimeSlider'), {
  ssr : false
});

const setTimeSliderMethods = methods => {
  timeSliderMethodsRef = methods;
};

export const timeSliderTrigger = ({
  map,
  view,
  timeline,
  featureFilter,
  timeSliderDisabled,
  assetsHistory
}: TimeSliderTriggerProps) => {
  view.ui.empty(MapToolPositions.topLeft);
  if (timeline?.isTimeSliderOn && !timeSliderDisabled) {
    addComponent({
      id        : 'time-slider-container',
      position  : MapToolPositions.topLeft,
      component : (
        <DynamicAssetHistoryMap map={map}
          view={view}
          timeline={timeline}
          assetsHistory={assetsHistory}
          featureFilter={featureFilter}
          setTimeSliderMethods={setTimeSliderMethods} />
      ),
      view
    });
  } else {
    if (timeSliderMethodsRef?.destroy) {
      timeSliderMethodsRef.destroy(map, view);
      timeSliderMethodsRef = null;
    }
    removeComponent('time-slider-container', view);
  }
};
